function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "25",
  height: "23",
  viewBox: "0 0 25 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "25",
  height: "22.727",
  rx: "6",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.318 11.522c0-.483-.044-.948-.126-1.394h-6.553v2.637h3.745a3.134 3.134 0 01-1.389 2.058v1.71h2.249c1.315-1.186 2.074-2.934 2.074-5.01z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.639 18.183c1.878 0 3.453-.61 4.604-1.652l-2.248-1.71c-.623.408-1.42.65-2.356.65-1.812 0-3.346-1.2-3.893-2.811H6.422v1.767c1.144 2.228 3.497 3.756 6.217 3.756z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.746 12.659a4.025 4.025 0 01-.218-1.296c0-.45.08-.886.218-1.295V8.3H6.422a6.706 6.706 0 000 6.124l2.324-1.766z",
  fill: "#FBBC05"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.639 7.258c1.021 0 1.938.344 2.66 1.02l1.995-1.956c-1.205-1.1-2.78-1.776-4.655-1.776-2.72 0-5.073 1.528-6.217 3.756l2.324 1.767c.547-1.612 2.08-2.811 3.893-2.811z",
  fill: "#EA4335"
})));